module.exports = __webpack_public_path__ + "1e0e8a9051942e9c8ed6755c00270c0a.svg";